import { TableColumnType } from 'src/types/table';

export const REQUIRED_RECEIVINGS_GRID_COLUMNS = ['ESHOP_RECEIVING_ID', 'ID', 'STATUS'];
export const REQUIRED_RECEIVINGS_GRID_ALL_PROVIDERS_COLUMNS = [...REQUIRED_RECEIVINGS_GRID_COLUMNS, 'ESHOP_KEY'];

export const allColumns: TableColumnType[] = [
    { key: 'ID', label: 'id', type: 'id' },
    { key: 'ASN', label: 'asn', defaultShow: true },
    { key: 'ESHOP_RECEIVING_ID', label: 'eshopReceivingId', defaultShow: true },
    { key: 'CREATED_AT', label: 'dateCreated', defaultShow: true, type: 'dateTime' },
    { key: 'QUANTITY', label: 'awaitingQuantity', defaultShow: true, type: 'number' },
    { key: 'RECEIVED', label: 'receivedQuantity', defaultShow: true, type: 'number' },
    { key: 'DIFF_QUANTITY', label: 'differentialQuantity', defaultShow: true, type: 'number' },
    {
        key: 'STATUS',
        label: 'status',
        defaultShow: true,
        type: 'select',
        selectOption: 'receivingStatusCodes',
        customRender: true,
        optionStyleFce: true
    },
    { key: 'ESTIMATED_DELIVERY', label: 'estimatedDelivery', defaultShow: true, type: 'dateTime' },
    { key: 'REAL_DELIVERY', label: 'realDelivery', type: 'dateTime' },
    { key: 'UNLOADED_AT', label: 'unloadedAt', type: 'dateTime', defaultShow: true },
    { key: 'RECEIVED_AT', label: 'receivedAt', type: 'dateTime', defaultShow: false },
    { key: 'CONFIRMED_AT', label: 'confirmedAt', type: 'dateTime', defaultShow: true },
    { key: 'CANCELED_AT', label: 'canceledAt', type: 'dateTime' },

    { key: 'URGENT', label: 'urgent', type: 'select', selectOption: 'receivingUrgentCodes', defaultShow: true, customRender: true },
    {
        key: 'DESCRIPTION',
        label: 'description',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
        defaultShow: true
    },
    {
        key: 'SKLADON_NOTE',
        label: 'skladonNote',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' }
    },
    {
        key: 'ESHOP_NOTE',
        label: 'eshopNote',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' }
    },
    { key: 'PRIORITY', label: 'priority', type: 'select', selectOption: 'receivingPriorityCodes' },
    { key: 'UNITS_AMOUNT', label: 'unitsAmount', type: 'number', defaultShow: true },
    // Swap order: show delivered cartons before announced pallets
    { key: 'DELIVERED_CARTONS_COUNT', label: 'deliveredCartonsCount', type: 'number', defaultShow: true },
    { key: 'ANNOUNCED_PALLETS_COUNT', label: 'announcedPalletsCount', type: 'number', defaultShow: true },
    // EUR pallets delivered (renamed via translations)
    { key: 'DELIVERED_PALLETS_COUNT', label: 'deliveredPalletsCount', type: 'number', defaultShow: true },
    // New columns between delivered EUR pallets and receiving type
    { key: 'RETURNED_EUR_PALLETS_COUNT', label: 'returnedEurPalletsCount', type: 'number', defaultShow: true },
    { key: 'DELIVERED_STANDARD_PALLETS_COUNT', label: 'deliveredStandardPalletsCount', type: 'number' },
    { key: 'RETURNED_STANDARD_PALLETS_COUNT', label: 'returnedStandardPalletsCount', type: 'number' },
    { key: 'DELIVERED_OTHER_PALLETS_COUNT', label: 'deliveredOtherPalletsCount', type: 'number' },
    { key: 'DELIVERED_BROKEN_PALLETS_COUNT', label: 'deliveredBrokenPalletsCount', type: 'number' },
    {
        key: 'RECEIVING_TYPE',
        label: 'receivingType',
        type: 'select',
        selectOption: 'receivingTypeCodes',
        defaultShow: true
    },
    { key: 'SUPPLIER', label: 'supplier' },
    { key: 'DELIVERY_NOTE_NUMBER', label: 'deliveryNoteNumber', defaultShow: true },
    {
        key: 'DELIVERY_TYPE',
        label: 'deliveryType',
        type: 'select',
        selectOption: 'receivingDeliveryTypeCodes',
        defaultShow: true
    },
    { key: 'CONTAINER_NUMBER', label: 'containerNumber' },
    {
        key: 'DRIVER_COMPANY',
        label: 'driverCompany',
        type: 'select',
        selectOption: 'driverCompanyCodes',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
        defaultShow: true
    },
    {
        key: 'DRIVER_COMPANY_OTHER_NAME',
        label: 'driverCompanyOtherName',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
        defaultShow: true
    },
    { key: 'TRACKING_NUMBER', label: 'trackingNumber', defaultShow: true },
    {
        key: 'DRIVER_NAME',
        label: 'driverName',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' }
    },
    {
        key: 'DRIVER_PHONE',
        label: 'driverPhone',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' }
    },
    {
        key: 'DRIVER_DISPATCHER_CONTACT',
        label: 'dispatcherContact',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' }
    },
    {
        key: 'DRIVER_TRAILER_LICENSE_PLATE',
        label: 'driverTrailerLicensePlate',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' }
    },
    { key: 'INCOTERMS', label: 'incoterms', type: 'select', selectOption: 'incotermsCodes' },
    { key: 'SLA_DATE', label: 'slaDate', type: 'dateTime' },
    { key: 'SLA_SUSPENDED', label: 'slaSuspended' },
    { key: 'DUTY', label: 'duty', type: 'select', selectOption: 'boolNumberCodes' },
    {
        key: 'PHOTO_DOCUMENTATION_TAKEN',
        label: 'photoDocumentationTaken',
        type: 'select',
        selectOption: 'boolNumberCodes'
    },

    // -
];

export const allColumnsWithProvider: TableColumnType[] = [
    {
        key: 'providerName',
        label: 'providerName',
        allwaysShow: true,
        forceFirst: true,
        disableFilter: true,
        disableSort: true
    },
    ...allColumns
];

export const extendProductColumns: TableColumnType[] = [
    { key: 'SKU', label: 'productSKU' },
    { key: 'NAME', label: 'productName' },
    { key: 'PRODUCT_QUANTITY', label: 'productQuantity' },
    { key: 'PRODUCT_RECEIVED', label: 'productReceived' }
];

export const extendProductDiffColumns: TableColumnType[] = [
    { key: 'PRODUCT_DIFF_QUANTITY', label: 'productDiffQuantity' }
];
